/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Transfer creation request
 */
export interface TransferCreationRequest {
  /**
   * Account ID
   */
  accountId: number;
  /**
   * Asset ID
   */
  assetId: number;
  /**
   * Transfer quantity. Use asset.qtyScale.
   */
  quantity: number;
  /**
   * Deposit or Withdraw
   */
  direction: TransferCreationRequest.DirectionEnum;
  /**
   * Note for admins
   */
  noteForAdmin?: string;
  /**
   * Note for client
   */
  noteForClient?: string;
  /**
   * May be used to create transfers in the past.
   */
  pastSettlementTime?: string;
}
export namespace TransferCreationRequest {
  export const DirectionEnum = {
    Deposit: 'DEPOSIT',
    Withdraw: 'WITHDRAW',
    Internal: 'INTERNAL',
    DepositRebate: 'DEPOSIT_REBATE',
    WithdrawRebate: 'WITHDRAW_REBATE',
    InternalDeposit: 'INTERNAL_DEPOSIT',
    InternalWithdraw: 'INTERNAL_WITHDRAW',
  } as const;
  export type DirectionEnum = (typeof DirectionEnum)[keyof typeof DirectionEnum];
}
